import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ModalTerms from '../ModalTerms/ModalTerms';
import ModalPrivacy from '../ModalPrivacy/ModalPrivacy';
import useQueryParams from '../../hooks/useQueryParams';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import FooterAbout from './components/FooterAbout/FooterAbout';
import FooterQuickLinks from './components/FooterQuickLinks/FooterQuickLinks';
import FooterContact from './components/FooterContact/FooterContact';
import FooterSocial from './components/FooterSocial/FooterSocial';
import FooterPayments from './components/FooterPayments/FooterPayments';
import FooterBottomBar from './components/FooterBottomBar/FooterBottomBar';
import styles from './AppFooter.module.css';

export default function AppFooter({ onlyFooterBottom, menuSideBar }) {
  const { t } = useTranslation('footer');
  const query = useQueryParams();
  const location = useLocation();
  const { width } = useWindowDimensions();
  const [modalTermsVisible, setModalTermsVisible] = useState(false);
  const [modalPrivacyVisible, setModalPrivacyVisible] = useState(false);
  const [tipoTermoUso, setTipoTermoUso] = useState(null);
  const [paddingFooter, setPaddingFooter] = useState(false);

  const openTermsOfUse = (e, tipo) => {
    e.preventDefault();
    e.stopPropagation();
    setTipoTermoUso(tipo);
    setModalTermsVisible(true);
  };

  const openPrivacy = e => {
    e.preventDefault();
    e.stopPropagation();
    setModalPrivacyVisible(true);
  };

  useEffect(() => {
    if (query && query.get('politicaPrivacidade')) {
      setModalPrivacyVisible(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (menuSideBar && width <= 768) {
      setPaddingFooter(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <footer id='footer' className={styles.root} aria-label={t('FOOTER_NAV')}>
      {modalTermsVisible && (
        <ModalTerms
          tipo={tipoTermoUso}
          modalVisible={modalTermsVisible}
          handleOk={() => setModalTermsVisible(false)}
          handleCancel={() => setModalTermsVisible(false)}
        />
      )}
      {modalPrivacyVisible && (
        <ModalPrivacy
          modalVisible={modalPrivacyVisible}
          handleOk={() => setModalPrivacyVisible(false)}
          handleCancel={() => setModalPrivacyVisible(false)}
        />
      )}
      {!onlyFooterBottom && (
        <div className={styles.top}>
          <div className={styles.topInner}>
            <div className={styles.grid}>
              <FooterAbout />
              <div className={styles.colGroup}>
                <FooterQuickLinks
                  openTermsOfUse={openTermsOfUse}
                  openPrivacy={openPrivacy}
                />
                <FooterContact />
              </div>
              <FooterSocial />
              <FooterPayments />
            </div>
          </div>
        </div>
      )}
      <FooterBottomBar menuSideBar={paddingFooter} />
    </footer>
  );
}

AppFooter.propTypes = {
  onlyFooterBottom: PropTypes.bool,
  menuSideBar: PropTypes.bool
};
